module.exports = __webpack_public_path__ + "img/news-04.0e125fb6.png";